import React from 'react';

class AddRuleItem extends React.Component {
    select() {
        this.props.select({
            'key' : this.props.ruleKey,
            'operator' : this.props.operator,
            'value' : this.props.value,
            'action' : this.props.action
        });
    }

    render() {
        return (
            <li className="list-group-item">
                <div className="media">
                    <div className="media-left" style={{verticalAlign:'middle'}}>
                        <a className="avatar" href="javascript:void(0)" style={{width:'40px'}}>
                            <img className="img-fluid" src="/images/svg/select.svg" alt="..." style={{borderRadius:0}} />
                        </a>
                    </div>
                    <div className="media-body">
                        <h4 className="media-heading">{this.props.title}</h4>
                        <small>{this.props.description}</small>
                    </div>
                    <div className="media-right">
                        <button onClick={this.select.bind(this)} className="btn btn-dark btn-block">Select</button>
                    </div>
                </div>
            </li>
        )
    }
}

export default AddRuleItem;





// WEBPACK FOOTER //
// ./components/builder/AddRuleItem.js